import axios, { AxiosInstance } from 'axios';
import * as API from '../../../constants/API';
import { MCITestRecord } from '../../../constants/Records';

export class MCIApiClient {
  private api: AxiosInstance;

  static async ClientFactory(): Promise<MCIApiClient> {
    return new MCIApiClient();
  }

  constructor() {
    const apiKey = process.env.REACT_APP_MCI_API_KEY || '';

    this.api = axios.create({
      baseURL: API.mciApiRoot,
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
      },
    });
  }

  // スコア件数取得（効率的なカウント用）
  async getScoreCount(uniqueId: string): Promise<number> {
    const res = await this.api.get(`/mci/users/${uniqueId}/scores`);
    // APIレスポンスは { total: number, data: MCITestRecord[] } 形式
    return res.data.total || 0;
  }

  // スコア一覧取得
  async getScores(uniqueId: string): Promise<MCITestRecord[]> {
    const res = await this.api.get(`/mci/users/${uniqueId}/scores`);
    // APIレスポンスは { total: number, data: MCITestRecord[] } 形式
    return res.data.data || [];
  }

  // 特定スコア取得
  async getScore(uniqueId: string, timestamp: string): Promise<MCITestRecord> {
    const res = await this.api.get(`/mci/users/${uniqueId}/scores/${timestamp}`);
    return res.data;
  }

  // 最新スコア取得
  async getLatestScore(uniqueId: string): Promise<MCITestRecord> {
    const res = await this.api.get(`/mci/users/${uniqueId}/latest`);
    return res.data;
  }

  // 期間指定取得
  async getScoresByDateRange(uniqueId: string, fromTimestamp: string, toTimestamp: string): Promise<MCITestRecord[]> {
    const res = await this.api.get(`/mci/users/${uniqueId}/scores/from/${fromTimestamp}/to/${toTimestamp}`);
    // APIレスポンスは { total: number, data: MCITestRecord[] } 形式
    return res.data.data || [];
  }

  // スコア作成
  async createScore(uniqueId: string, data: Partial<MCITestRecord>): Promise<MCITestRecord> {
    const res = await this.api.post(`/mci/users/${uniqueId}/scores`, data);
    return res.data;
  }

  // スコア更新
  async updateScore(uniqueId: string, timestamp: string, data: Partial<MCITestRecord>): Promise<MCITestRecord> {
    const res = await this.api.put(`/mci/users/${uniqueId}/scores/${timestamp}`, data);
    return res.data;
  }

  // スコア削除
  async deleteScore(uniqueId: string, timestamp: string): Promise<void> {
    await this.api.delete(`/mci/users/${uniqueId}/scores/${timestamp}`);
  }
}
